import { useEffect } from 'react';
import { useSEO } from '../../utils/seo';
import PageHero from './components/PageHero';
import PhilosophySection from './components/PhilosophySection';
import ValuesSection from './components/ValuesSection';
import MessageSection from './components/MessageSection';
import FeaturesSection from './components/FeaturesSection';
import CommunitySection from './components/CommunitySection';

export default function AboutPage() {
  useSEO({
    title: 'まごころヘルパーについて | 逗子市訪問介護サービスの理念と想い',
    description: 'まごころヘルパーは逗子市で訪問介護サービスを提供する介護事業者です。「利用者様の笑顔と尊厳を守る」という理念のもと、一人ひとりに寄り添った質の高い介護サービスを提供しています。代表メッセージ、企業理念、サービスの特徴をご紹介します。',
    keywords: '訪問介護,逗子市,まごころヘルパー,企業理念,代表メッセージ,介護サービス理念',
    path: '/about',
    schema: {
      "@context": "https://schema.org",
      "@type": "AboutPage",
      "name": "まごころヘルパーについて",
      "description": "まごころヘルパーは逗子市で訪問介護サービスを提供する介護事業者です。利用者様の笑顔と尊厳を守るという理念のもと、質の高い介護サービスを提供しています。",
      "url": `${import.meta.env.VITE_SITE_URL}/about`,
      "mainEntity": {
        "@type": "Organization",
        "name": "まごころヘルパー",
        "description": "逗子市で訪問介護サービスを提供する介護事業者"
      }
    }
  });

  useEffect(() => {
    window.scrollTo(0, 0);
    
    const observerOptions = {
      threshold: 0.1,
      rootMargin: '0px 0px -100px 0px'
    };

    const observer = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          entry.target.classList.add('animate-fade-in-up');
        }
      });
    }, observerOptions);

    document.querySelectorAll('.observe-animation').forEach((el) => {
      observer.observe(el);
    });

    return () => observer.disconnect();
  }, []);

  return (
    <div className="min-h-screen bg-white">
      <PageHero />
      <PhilosophySection />
      <ValuesSection />
      <MessageSection />
      <FeaturesSection />
      <CommunitySection />
    </div>
  );
}
